import React from 'react';
import Widget from '../Widget';
import WidgetTitle from '../WidgetTitle';
import WidgetDescription from '../WidgetDescription';
import { Col, Row } from 'react-bootstrap';
import DoughnutChart from '../../Charts/DoughnutChart';
import KeyValueData from '../../Charts/KeyValueData';
import TableToggle from '../TableToggle';
import { fixCIP } from '../../../utilities/formats';
import useTableToggle from '../../Hooks/useTableToggle';
import NoData from '../NoData';

export default function AcademicProgramMix({ institutionData }) {
    const { table, handleTable } = useTableToggle();
    const widgetTitle = 'Academic Program Mix';

    let label = institutionData.post_meta.apm.label;

    if (!label || label == 'N/A') {
        return <NoData widgetTitle={widgetTitle} />;
    }

    // if label includes a : add a line break after it
    // add a few other breaks to handle long labels
    label = label.replace(/:/g, ":\\n")
        .replace(/ and /g, " \\nand ");

    const slots = 5;
    const programs = [];
    for (let i = 1; i <= slots; i++) {
        const field = 'apm_name_' + i;
        const count = 'apm_percent_' + i;

        if (institutionData.post_meta[count].value) {
            programs.push({
                label: fixCIP(institutionData.post_meta[field].value),
                value: parseFloat(institutionData.post_meta[count].value * 100),
            });
        }
    }

    if (institutionData.post_meta.apm_remainder_percent.value) {
        programs.push({
            label: fixCIP(institutionData.post_meta.apm_remainder_name.value),
            value: parseFloat(institutionData.post_meta.apm_remainder_percent.value * 100),
        })
    }


    return (
        <Widget className="academic-program-mix">
            <Row>
                <Col xs={12} sm={9}>
                    <WidgetTitle>{widgetTitle}</WidgetTitle>
                </Col>
                <Col xs={12} sm={3}>
                    <TableToggle handleTable={handleTable} table={table} />
                </Col>
            </Row>
            <WidgetDescription>
                The program areas in which students receive their undergraduate degrees.
            </WidgetDescription>

            {!table ? (
                <div className="d-block d-md-flex">
                    <div className="w-50">
                        <DoughnutChart data={programs} centerText={label} legendDiv="acaMixLegend" numberFormat="percent" />
                    </div>
                    <div className='dotLegend w-50 d-flex align-items-center p-3' id='acaMixLegend'></div>
                </div>
            ) : <KeyValueData data={programs} numberFormat="percent" />}
        </Widget>
    );
}